import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialog, MatDialogModule, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EntityType } from '../shared/share';
import { StatusLablesComponent } from "../shared/components/status-lables/status-lables.component";
import { ImageviewerComponent } from '../shared/imageviewer/imageviewer.component';
import { AddPatientComponent } from '../add-patient/add-patient.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FillExtraInfoComponent } from '../fill-extra-info/fill-extra-info.component';
import { MemberInsurerServiceService } from '../../services/member-insurer-service.service';
import { SubmitMedicalEvidenceComponent } from '../submit-medical-evidence/submit-medical-evidence.component';
import { Roles } from '@app/modules/lps-member-login/models/commonmodel';
import { RequestMoreDetailsComponent } from '../request-more-details/request-more-details.component';
import { Subscription } from 'rxjs';
import { AgePipe } from "../shared/pipes/age.pipe";
import { RequestMedicalEvidenceComponent } from '../request-medical-evidence/request-medical-evidence.component';
import { MemberInsurerRestService } from '../../services/member-insurer-rest.service';
import { ThemeserviceService } from '../theme/themeservice.service';
import { InitialsPipe } from '../shared/pipes/intials.pipe';
import { PatientData } from '../../models/phase1models';
@Component({
  selector: 'app-patient-profile',
  standalone: true,
  imports: [CommonModule, MatTabsModule, MatDialogModule, StatusLablesComponent, MatTooltipModule, AgePipe, InitialsPipe],
  templateUrl: './patient-profile.component.html',
  styleUrl: './patient-profile.component.scss'
})
export class PatientProfileComponent {

  constructor(private theme: ThemeserviceService, public dialogRef: MatDialogRef<PatientProfileComponent>, private restService: MemberInsurerRestService, private memberService: MemberInsurerServiceService, private dialog: MatDialog, public MemberInsurerServiceService: MemberInsurerServiceService, @Inject(MAT_DIALOG_DATA) public data: any) { }

  @Output() closeDrawer = new EventEmitter<void>();
  activeTab = 'details';
  selectedIndex = 0;
  enumEntityType = EntityType;
  enumRole = Roles;
  copiedEmail: string | null = null;
  selectedPatient!: PatientData;
  private patientSubscription: Subscription | undefined;
  patientId!: string;
  role = this.memberService.getLoginUserRole()
  popupTitle = 'Applicant Details';
  popupSubtitle = 'The complete details of the applicant and the history of requests will be displayed here.';
  userId = this.memberService.getLoginUserId();

  // Helper function to get status icon/color (you'd style this with CSS)
  getStatusClass(status: string | undefined): string {
    switch (status) {
      case 'Pending review':
        return 'status-pending';
      case 'Needs changes':
        return 'status-needs-changes';
      case 'Approved':
        return 'status-approved';
      default:
        return '';
    }
  }

  // Helper function to get initials color (you'd style this with CSS)
  getInitialsColorClass(initials: string): string {
    // Basic example: assign different colors based on initials or a hash function
    const colors = ['color-blue', 'color-green', 'color-purple', 'color-orange'];
    const index = initials.charCodeAt(0) % colors.length;
    return colors[index];
  }


  ngOnInit(): void {
     this.patientId=this.data.patientId;
    const role = this.memberService.getLoginUserRole()
    this.theme.applyTheme(role)
    if(this.data.id){
      this.restService.getMemberById(this.data.patientId).subscribe({
        next:(value)=>{
          this.selectedPatient=value;
          console.log(value);
        },error:(err)=>{
          console.log(err)
        }
      })

    }

    console.log(this.data)
    // this.selectedPatient=this.data;
    // code by row element by yashwanth
    this.patientSubscription = this.memberService.selectedPatient$.subscribe(
      (patient) => {
        if (patient) {
          this.patientId = patient.patientId;
          this.getMemberById();
        }
      }
    );
  }

  isItSameProvider(evidence: any) {
    return this.memberService.getLoginUserId() == evidence.provider.id;
  }

  getMemberById(): void {
    if (!this.patientId) {
      console.warn('No patientId provided');
      return;
    }

    this.restService.getMemberById(this.patientId).subscribe({
      next: (response: PatientData) => {
        this.selectedPatient = response;
        console.log('Patient found from API:', this.selectedPatient);
      },
      error: (err) => {
        console.error('Failed to fetch patient by ID:', err);
      }
    });
  }


  ngOnDestroy(): void {
    if (this.patientSubscription) {
      this.patientSubscription.unsubscribe();
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }

  copyToClipboard(value: string) {
    navigator.clipboard.writeText(value);
    this.copiedEmail = value;
    setTimeout(() => {
      this.copiedEmail = null;
    }, 1200);
  }

  openRequestME() {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '900px';
    dialogConfig.height = '600px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.enterAnimationDuration = 200;
    dialogConfig.data = {
      memberId: this.selectedPatient.patientId
    }
    const dialogRef = this.dialog.open(RequestMedicalEvidenceComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {

      }
    });
  }

  editProfile() {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '900px';
    dialogConfig.height = '600px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.enterAnimationDuration = 200;
    dialogConfig.data = {
      memberId: this.selectedPatient.patientId
    }
    const dialogRef = this.dialog.open(AddPatientComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {

      }
    });
  }

  onFillMoreInfo() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '700px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.data = this.selectedPatient;
    const dialogRef = this.dialog.open(FillExtraInfoComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // Handle any actions after the image viewer is closed
      }
    });
  }

  onRequestMoreDetails() {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '700px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.enterAnimationDuration = 200;
    dialogConfig.data = this.selectedPatient;
    const dialogRef = this.dialog.open(RequestMoreDetailsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {

      }
    });
  }

  openMedicalEvidence() {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '700px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.enterAnimationDuration = 200;
    dialogConfig.data = this.selectedPatient;
    const dialogRef = this.dialog.open(SubmitMedicalEvidenceComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {

      }
    });
  }

  medicalEvidenceList = [
    {
      title: 'CT Scan Report',
      submittedBy: 'Dr. Sarah Malik, NHS Manchester',
      date: new Date('2025-03-22T15:45:00'), // 3:45 PM
      description: 'CT scan of the thorax shows no acute abnormalities.',
      documents: ['ct_scan_thorax.pdf']
    },
    {
      title: 'Pathology Report',
      submittedBy: 'Dr. Rajiv Mehta, LabCorp UK',
      date: new Date('2025-02-18T09:30:00'), // 9:30 AM
      description: 'Biopsy confirms benign results. No malignancy detected.',
      documents: ['pathology_results.pdf', 'biopsy_slides.jpg']
    },
    {
      title: 'MRI Brain Screening',
      submittedBy: 'Dr. Alicia Roberts, Bupa Diagnostics',
      date: new Date('2025-01-05T13:15:00'), // 1:15 PM
      description: 'Brain MRI reveals no structural concerns.',
      documents: ['mri_brain_screening.pdf']
    }
  ];


  openDocument(doc: any) {
    console.log('doc', doc);

    // Use actual document path and name
    const fileUrl = doc.documentPath;
    const fileName = doc.documentOriginalName || doc.documentName;

    // Generate viewer URL
    const url = `/#/viewer?file=${encodeURIComponent(fileUrl)}&name=${encodeURIComponent(fileName)}`;

    // Open in new tab
    window.open(url, '_blank');
  }


  getTurnAroundTime(row: any): string {
    if (!row) {
      return '';
    }

    const createdOn = new Date(row.createdon);
    const now = new Date();

    if (row.status?.toLowerCase() !== 'received') {
      // Difference between createdOn and now
      return this.formatDuration(createdOn, now);
    } else {
      const lastUpdatedOn = new Date(row.lastupdatedon);
      // Difference between createdOn and lastUpdatedOn
      return this.formatDuration(createdOn, lastUpdatedOn);
    }
  }

  private formatDuration(start: Date, end: Date): string {
    let msDiff = end.getTime() - start.getTime();

    if (msDiff < 0) {
      msDiff = 0;
    }

    let totalMinutes = Math.floor(msDiff / (1000 * 60));

    const years = Math.floor(totalMinutes / (60 * 24 * 365));
    totalMinutes -= years * 60 * 24 * 365;

    const months = Math.floor(totalMinutes / (60 * 24 * 30));
    totalMinutes -= months * 60 * 24 * 30;

    const weeks = Math.floor(totalMinutes / (60 * 24 * 7));
    totalMinutes -= weeks * 60 * 24 * 7;

    const days = Math.floor(totalMinutes / (60 * 24));
    totalMinutes -= days * 60 * 24;

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    const parts = [];

    if (years) parts.push(`${years}y`);
    if (months) parts.push(`${months}m`);
    if (weeks) parts.push(`${weeks}w`);
    if (days) parts.push(`${days}d`);
    if (hours) parts.push(`${hours}hrs`);
    if (minutes || parts.length === 0) parts.push(`${minutes}m`);

    return parts.join(' ');
  }

  messages = [
  {
    id: 'msg1',
    sender: 'insurer',
    avatarInitial: 'IN',
    timestamp: new Date('2024-07-10T10:00:00Z'),
    comment: 'We require further details regarding the recent claim for policy #XYZ789. Please provide the medical reports from May 2024.'
  },
  {
    id: 'msg2',
    sender: 'provider',
    avatarInitial: 'PR',
    timestamp: new Date('2024-07-10T10:15:00Z'),
    comment: 'Acknowledged. We are compiling the requested reports. Please find attached the initial diagnostic summary.',
    files: [{ fileName: 'diagnostic_summary.pdf', url: '#' }] // Placeholder URL
  },
  {
    id: 'msg3',
    sender: 'insurer',
    avatarInitial: 'IN',
    timestamp: new Date('2024-07-10T11:30:00Z'),
    comment: 'Thank you. We also need clarification on the treatment plan for the patient, specifically regarding the duration of therapy.'
  },
  {
    id: 'msg4',
    sender: 'provider',
    avatarInitial: 'PR',
    timestamp: new Date('2024-07-10T14:00:00Z'),
    comment: 'The treatment plan is designed for 12 weeks, with a review at week 6. Detailed plan attached.',
    files: [{ fileName: 'treatment_plan.docx', url: '#' }] // Placeholder URL
  },
  {
    id: 'msg5',
    sender: 'insurer',
    avatarInitial: 'IN',
    timestamp: new Date('2024-07-11T09:00:00Z'),
    comment: 'Understood. Could you also provide the patient\'s consent form for data sharing?'
  }
];

}